import { Container } from 'inversify';
import 'reflect-metadata';
export var injector = new Container();
//# sourceMappingURL=injector.js.map